import styled from '@emotion/styled';

export const StyledReportWrap = styled.div`
  margin-top: 15px;
`;

export const SettingWrapper = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  background: #fff;
  padding: 20px 40px;
  /* padding: 47.65px 40px 46.35px; */
  margin-top: 10px;
  &:first-of-type {
    margin-top: 0;
  }
  & > strong {
    position: relative;
    display: block;
    width: 200px;
    height: 24px;
    font-size: 16px;
    line-height: 23px;
  }
`;

export const SettingBox = styled.div`
  position: relative;
  width: calc(100% - 232px);
  margin-left: 32px;
  padding-top: 10px;
  padding-bottom: 10px;

  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: -32px;
    background: #e0e0e0;
  }

  & > :last-child {
    margin-bottom: 0;
  }

  & .hospital-name {
    width: 420px;
    & input {
      padding: 0 16px;
    }
  }
`;

export const SettingList = styled.ul`
  position: relative;
  margin-bottom: 30px;

  & > li {
    display: flex;
    white-space: nowrap;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 28px;
    font-size: 16px;
    color: #333;
    &:first-of-type {
      margin-top: 0;
    }
  }
  & .guide-text {
    margin-top: 10px;
    font-weight: 400;
    font-size: 12px;
    color: #fa8282;
  }
  & .selectbox-text {
    margin-left: 5px;
    color: #484848;
  }
`;

export const StyledReportIndexOption = styled.ul`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  flex-flow: wrap;

  & li {
    margin-right: 30px;
    margin-bottom: 10px;
  }
`;

export const SwButtonSection = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 53px;
  & button {
    margin-top: 0;
  }
`;

export const SelectBox = styled.div`
  min-width: 84px;
  font-size: 14px;
  x & div {
    border-radius: 4px;
  }
  & ol {
    & li {
      padding: 0 16px;
      justify-content: left;
    }
  }
`;

export const TwoRowInputBox = styled.li`
  display: inline-block;
  padding: 4px 12px;
  width: 333px;
  border: 1px solid #6a6a6a;
  box-sizing: border-box;

  &.disabled {
    background-color: #eeeeee !important;
  }
`;

export const RowInput = styled.input`
  width: 100%;
  height: 30px;
  box-sizing: border-box;
  border: transparent;
  font-size: 12px;
  outline: none;

  &:disabled::placeholder {
    color: #0000004d;
  }
`;

export const RowDivider = styled.div`
  width: 100%;
  margin: 2px 0;
  border-top: 1px dashed #000000;
`;

export const StyledSettingLabel = styled.li`
  width: 160px;
  padding-top: 4px;
  align-self: flex-start;
`;

export const StyledImageUpload = styled.div`
  display: flex;
  width: 200px;
  height: 50px;
  align-items: flex-start;
  justify-content: flex-end;
  border: 1px dashed #6a6a6a;
  cursor: pointer;

  &.disabeld {
    cursor: default;
    color: #0000004d;
    background-color: #eeeeee !important;
  }

  font-size: 11px;

  input {
    display: none;
  }

  &.empty {
    align-items: center;
    justify-content: center;
  }

  &.f-width img {
    width: 100%;
  }

  &.f-height img {
    height: 100%;
  }
`;

export const StyledUploadInfo = styled.ul`
  margin-top: 6px;
  font-size: 12px;
  padding-left: 18px;
  color: #ff4c4c;

  li {
    list-style: disc;
  }
`;

export const StyledTextInfo = styled.li`
  align-self: flex-end;
  margin-left: 10px;
  font-size: 12px;
  color: #ff4c4c;
`;
